import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.closeJobDetails();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.jobDetailsTitle')) + "\n  ")];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.isTitle ? [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.table.title')) + ":  ")]), _c('span', {
    staticClass: "text-body-1",
    attrs: {
      "data-cy": "job_title"
    }
  }, [_vm._v(_vm._s(_vm.itemInfo.title) + " (ID: " + _vm._s(_vm.itemInfo.id) + ")")])])] : _vm._e(), _vm.hasExecutions && _vm.itemInfo.type === 'virtualDevicesEdit' ? [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.changes')) + ":  ")]), _c('div', _vm._l(Object.entries(_vm.itemInfo.executions), function (item, i) {
    return _c(VChip, {
      key: i,
      staticClass: "ma-1"
    }, [item[0] === 'params' && item[1].deviceTemplate ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.templateSyncronize')) + "\n              ")])] : _vm._e(), item[0] === 'deletionOfDevices' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.deletedDevices')) + "\n              ")])] : _vm._e(), item[0] === 'operationalStatus' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.setOperationalStatusTo')) + ":  \n              ")]), _vm._v("\n              " + _vm._s(_vm.operationalStatus[item[1]].text) + "\n            ")] : item[0] === 'syncHealthConfiguration' && item[1] ? [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.syncronizeHealthState')) + " ")])] : item[0] === 'tags' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.addTag')) + ":  ")]), _vm._v("\n              " + _vm._s(item[1].join(', ')) + "\n            ")] : item[0] === 'groups' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.addGroup')) + ":  ")]), _vm._v("\n              " + _vm._s(item[1].join(', ')) + "\n            ")] : item[0] === 'tagsToRemove' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.removeTag')) + ":  ")]), _vm._v("\n              " + _vm._s(item[1].join(', ')) + "\n            ")] : item[0] === 'groupsToRemove' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.removeGroup')) + ":  \n              ")]), _vm._v("\n              " + _vm._s(item[1].join(', ')) + "\n            ")] : item[0] === 'parentId' ? [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.changeParentalObjectTo')) + ":  \n              ")]), _vm._v("\n              " + _vm._s(_vm.parentTitle) + "\n            ")] : _vm._e()], 2);
  }), 1)] : _vm._e(), _vm.isCreatedAt ? [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.table.createdAt')) + ":  ")]), _c('span', {
    staticClass: "text-body-1"
  }, [_vm._v(_vm._s(_vm.localizeDate(_vm.itemInfo.createdAt)))])])] : _vm._e(), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.createdBy')) + ":  ")]), _vm.userCreated ? [_c('span', {
    staticClass: "text-body-1"
  }, [_vm.userDisplayName ? [_c('div', {
    staticClass: "user-email text-truncate",
    attrs: {
      "title": `${_vm.userDisplayName} - (${_vm.itemInfo.userCreated.email})`
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.userDisplayName))]), _vm._v("\n                -\n                "), _c('span', [_vm._v("(" + _vm._s(_vm.itemInfo.userCreated.email) + ")")])])] : [_c('div', {
    staticClass: "user-email text-truncate",
    attrs: {
      "title": _vm.itemInfo.userCreated.email
    }
  }, [_vm._v("\n                " + _vm._s(_vm.itemInfo.userCreated.email) + "\n              ")])]], 2)] : _vm._e()], 2), _vm.itemInfo.type === 'deviceStatesCsvExport' ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.exportTimerange')) + ":  ")]), _c('span', {
    staticClass: "text-body-1"
  }, [_vm._v("\n          " + _vm._s(_vm.localizeDate(_vm.get(_vm.itemInfo, 'executions.params.fromTime'), {
    format: 'L LTS'
  })) + " -\n          " + _vm._s(_vm.localizeDate(_vm.get(_vm.itemInfo, 'executions.params.toTime'), {
    format: 'L LTS'
  })) + "\n        ")])]) : _vm._e(), _c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.isExportForDigitalTwins ? _c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.numberOfTwins')) + ":  \n        ")]) : _c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.devicesNumber')) + ":  \n        ")]), _vm.isTasksTotal ? [_c('span', {
    staticClass: "text-body-1"
  }, [_vm._v("\n            " + _vm._s(_vm.numberOfDevices) + "\n          ")])] : _vm._e()], 2), _vm.hasErrors ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.table.errors')) + ":  ")]), [_c('span', {
    staticClass: "red--text"
  }, [_vm._v("\n            " + _vm._s(_vm.itemInfo.tasks.errors) + "\n          ")])]], 2) : _vm._e(), _vm.isState ? [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.status')) + ":  ")]), _c('span', {
    staticClass: "text-body-1 text-capitalize",
    class: {
      'red--text': !!_vm.failureReason || _vm.hasErrors > 0,
      'green--text': !_vm.failureReason && !_vm.hasErrors && _vm.itemInfo.state === 'done'
    },
    attrs: {
      "data-cy": "background_job_status"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.statusText) + "\n          ")])])] : _vm._e(), _vm.failureReason ? _c('div', {
    staticClass: "d-flex align-start"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.failureReason')) + ":  ")]), _c('span', {
    staticClass: "text-body-1 red--text",
    attrs: {
      "data-cy": "background_job_failure_reason"
    }
  }, [_vm._v(_vm._s(_vm.failureReason))])]) : _vm._e(), _vm.itemInfo.state === 'done' ? [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.finishedAt')) + ":  ")]), _c('span', {
    staticClass: "text-body-1"
  }, [_vm._v(_vm._s(_vm.localizeDate(_vm.itemInfo.finishedAt)))])])] : _vm._e()], 2), _vm.itemInfo.state === 'in progress' ? [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('hr'), _c('div', {
    staticClass: "d-flex justify-space-between align-center mt-5"
  }, [_c('div', {
    staticClass: "pa-1"
  }, [_c('p', {
    staticClass: "ma-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.status')))])]), _c('div', {
    staticClass: "progress-bar-contatiner pa-1"
  }, [_c(VProgressLinear, {
    attrs: {
      "color": _vm.color,
      "buffer-value": "0",
      "value": _vm.progressBarPercent,
      "stream": ""
    }
  })], 1), _c('div', {
    staticClass: "pa-1"
  }, [_c('p', {
    staticClass: "ma-0"
  }, [_vm._v("\n              " + _vm._s(_vm.itemInfo.tasks.done + _vm.itemInfo.tasks.errors) + "\n              " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(_vm.itemInfo.tasks.total) + "\n            ")])])]), _vm.autoRetryStatus ? _c('div', {
    staticClass: "d-flex justify-end align-center px-1"
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-redo")]), _c('span', {
    staticClass: "text-caption"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.autoRetrying', {
    attempt: _vm.autoRetryStatus.attempt,
    maxAttempts: _vm.autoRetryStatus.maxAttempts
  })) + "\n          ")])], 1) : _vm._e()])] : [_vm.items.length === 0 && _vm.isFetching ? [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-space-between align-center mt-5 w-100"
  }, [_c('hr', {
    staticClass: "w-100 mb-5"
  }), _c(VProgressCircular, {
    attrs: {
      "size": 50,
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1)])] : [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('hr'), _vm.canRetryAllFailed ? _c('div', {
    staticClass: "d-flex justify-end w-100 mt-3"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-undo",
      "loading": _vm.isRetryingAllFailed,
      "disabled": _vm.isRetryingAllFailed
    },
    on: {
      "click": _vm.triggerRetryAllFailed
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.retryAllFailed')) + "\n            ")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-space-between align-center mt-5"
  }, [_c(VDataTable, {
    staticClass: "row-pointer w-100",
    attrs: {
      "items": _vm.items,
      "items-per-page": _vm.tableOptions.itemsPerPage,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "sort-by": _vm.tableOptions.sortBy,
      "sort-desc": _vm.tableOptions.sortDesc,
      "must-sort": "",
      "expanded": _vm.expanded,
      "show-expand": ""
    },
    on: {
      "update:itemsPerPage": function ($event) {
        return _vm.$set(_vm.tableOptions, "itemsPerPage", $event);
      },
      "update:items-per-page": function ($event) {
        return _vm.$set(_vm.tableOptions, "itemsPerPage", $event);
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "update:sortBy": function ($event) {
        return _vm.$set(_vm.tableOptions, "sortBy", $event);
      },
      "update:sort-by": function ($event) {
        return _vm.$set(_vm.tableOptions, "sortBy", $event);
      },
      "update:sortDesc": function ($event) {
        return _vm.$set(_vm.tableOptions, "sortDesc", $event);
      },
      "update:sort-desc": function ($event) {
        return _vm.$set(_vm.tableOptions, "sortDesc", $event);
      },
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-expand",
      fn: function ({
        item,
        isExpanded
      }) {
        return [item.result && !item.result.success && !_vm.isProcessing ? [!isExpanded ? [_c(VIcon, {
          on: {
            "click": function ($event) {
              return _vm.handleExpansion(item, isExpanded);
            }
          }
        }, [_vm._v("fal fa-chevron-down")])] : [_c(VIcon, {
          on: {
            "click": function ($event) {
              return _vm.handleExpansion(item, isExpanded);
            }
          }
        }, [_vm._v("fal fa-chevron-up")])]] : _vm._e()];
      }
    }, {
      key: "expanded-item",
      fn: function ({
        headers,
        item
      }) {
        return [item.result && !item.result.success && !_vm.isProcessing ? [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [_vm._v("\n                    " + _vm._s(item.result.error) + "\n                  ")])] : _vm._e()];
      }
    }, {
      key: "item.entityId",
      fn: function ({
        item
      }) {
        return [_vm.constructUrl(item) ? [_c('router-link', {
          staticStyle: {
            "color": "inherit"
          },
          attrs: {
            "disabled": item.result && !item.result.success,
            "to": _vm.constructUrl(item)
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.entityUrlPrefix(item)) + " " + _vm._s(_vm.get(item, 'result.data.id')) + "\n                  ")])] : [_vm._v(_vm._s(item.entityId))]];
      }
    }, {
      key: "item.result.success",
      fn: function ({
        item
      }) {
        return [_c('div', [_vm._v("\n                  " + _vm._s(_vm.getStatus(item)) + "\n                ")])];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_vm.itemInfo.type !== 'deviceStatesCsvExport' && item.state !== 'canceled' && (!item.result || item.result.success === false) ? [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-undo"
          },
          on: {
            "click": function ($event) {
              return _vm.triggerTaskRetry(item);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.retryBtn')) + "\n                  ")])] : _vm._e()];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                    " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n                  ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n                ")])];
      },
      proxy: true
    }])
  })], 1)])]]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };